<template>
  <app-main-layout class="App-Page-H">
    <!--  -->
    <template v-slot:top-nav>
      <app-top-nav />
    </template>
    <!--  -->
    <template v-slot:main>
      <div>
        <AppFounderTop />
        <div>
          <app-how-it-works />
        </div>
      </div>
    </template>
    <!--  -->
    <template v-slot:footer>
      <app-main-footer />
    </template>
  </app-main-layout>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import AppFounderTop from "./founder-talent-top.vue";

@Options({
  components: { AppFounderTop },
})
export default class extends Vue {}
</script>

<style lang="scss"></style>
